import './Analytics.scss';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SideBar from '../../components/SideBar/SideBar';
import TopNav from '../../components/TopNav/TopNav';
import api from '../../services/api';

const EVENT_TYPE_LABELS = {
  venue_view: 'Venue Views',
  event_view: 'Event Views',
  search: 'Searches',
  venue_tap: 'Venue Taps',
  event_tap: 'Event Taps',
  bottle_service_view: 'Bottle Service Views',
  bottle_purchase_started: 'Bottle Purchase Started',
  ai_query: 'AI Queries',
  map_opened: 'Map Opens',
  venue_favorited: 'Venue Favorites',
  view_tables_clicked: 'View Tables Clicked',
  join_guestlist_clicked: 'Join Guestlist Clicked',
  ad_impression: 'Ad Impressions',
  ad_click: 'Ad Clicks',
  ad_dismiss: 'Ad Dismissals',
  app_update_popup_shown: 'App Popup Shown',
  app_update_popup_tapped: 'App Popup Tapped',
  force_update_shown: 'Update Screen Shown',
  force_update_tapped: 'Update Tapped',
};

const ActionsToday = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const days = searchParams.get('days') || 30;
  const [actions, setActions] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchActions = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/analytics/actions-breakdown?days=${days}`);
      setActions(data.data);
    } catch (error) {
      console.error('Error fetching actions breakdown:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchActions();
  }, [fetchActions]);

  return (
    <main>
      <TopNav />
      <div className="main-container">
        <SideBar />
        <article className="page-content">
          <section className="analytics">
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
              <button
                onClick={() => navigate('/analytics')}
                style={{ background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: 8, padding: '8px 16px', color: '#fff', cursor: 'pointer', fontSize: 14 }}>
                Back
              </button>
              <h1 className="analytics__title" style={{ margin: 0 }}>Actions ({days} days)</h1>
            </div>

            <div className="analytics__table" style={{ maxWidth: 600 }}>
              {loading ? (
                <div className="analytics__loading">Loading...</div>
              ) : (
                <table>
                  <thead>
                    <tr>
                      <th>Action</th>
                      <th>Count</th>
                      <th>Unique Users</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {actions.map((a) => (
                      <tr key={a.event_type}>
                        <td>{EVENT_TYPE_LABELS[a.event_type] || a.event_type}</td>
                        <td>{a.count}</td>
                        <td>{a.unique_users}</td>
                        <td>
                          <button
                            onClick={() => navigate(`/analytics/detail?days=${days}&event_type=${a.event_type}`)}
                            className="text-link">
                            View Users
                          </button>
                        </td>
                      </tr>
                    ))}
                    {actions.length === 0 && (
                      <tr><td colSpan={4} style={{ textAlign: 'center', color: 'rgba(255,255,255,0.3)' }}>No actions today</td></tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </section>
        </article>
      </div>
    </main>
  );
};

export default ActionsToday;
